export const DEFAULT_SHIFT_START_TIME_HOUR = 6;
export const DEFAULT_SHIFT_START_TIME_MINUTE = 0;
export const DEFAULT_SHIFT_MINUTE = 0;
